export default "__VITE_ASSET__BCl9ulxZ__"